/**
 * Refund Assist Status mapping between status IDs and status strings
 * @typedef {object} RefundAssistStatusEntry
 * @property {number} statusId - The numeric ID from the API
 * @property {string} statusString - The string representation for UI components
 */

export const REFUND_ASSIST_STATUS = {
  REFUND_SCHEDULED: {
    statusId: 2,
    statusString: 'refundscheduled',
  },
  REFUND_PENDING: {
    statusId: 3,
    statusString: 'refundpending',
  },
  REFUNDED: {
    statusId: 4,
    statusString: 'refunded',
  },
  REFUND_CANCELED: {
    statusId: 5,
    statusString: 'refundcanceled',
  },
  REFUND_REJECTED: {
    statusId: 6,
    statusString: 'refundrejected',
  },
};

/**
 * Get refund assist status string from status ID
 * @param {number} statusId - The refund status ID
 * @returns {string|undefined} The refund status string or undefined if not found
 */
export const getRefundAssistStatusString = (statusId) => {
  const statusEntry = Object.values(REFUND_ASSIST_STATUS).find((entry) => entry.statusId === statusId);
  return statusEntry?.statusString;
};
